export default __webpack_public_path__ + "static/media/Game 2 Manhattan City Skyline.fc81efc6.png";